import Link from 'next/link';

import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';

import { Avatar } from '@basic';
import { CreateIcon, SearchIcon } from '@icons';

export default function MainMenu() {
  const { t } = useTranslation();
  const { user, isLoading } = useAuth0();

  return (
    <>
      <div className='flex flex-col items-left bg-black text-gray-400 h-screen border-r border-gray-500 p-5'>
        <Link href='/goals/explore'>
          <span className='my-2 flex items-center'>
            <SearchIcon className='mr-2' />
            {t('components.mainMenu.links.explore')}
          </span>
        </Link>

        <Link href='/tasks/new/editor'>
          <span className='my-2 flex items-center'>
            <CreateIcon className='mr-2' />
            {t('components.mainMenu.links.create')}
          </span>
        </Link>

        {!isLoading && user && (
          <Link href='/accounts/me'>
            <Avatar src={user.picture} size={20} />
          </Link>
        )}

        <span className='my-2 flex items-center'>{t('components.mainMenu.links.collapse')}</span>
      </div>
    </>
  );
}
